// extracted by mini-css-extract-plugin
export var chaptersWrapperStyle = "toc_chapters_modal_controller-module--chaptersWrapperStyle--4iy3S";